import { useQuery } from 'react-query';

import { baseApiUrl, fetcher, ServerErrorResponse } from 'data_sources/constants';

import type { TextEntityResponse } from 'views/App/Portal/Policy/_types/manuals/draft';

export default function useTextEntities(options: object = {}, onError?: (errors: ServerErrorResponse) => void) {
  return useQuery<{ content: TextEntityResponse[] }, ServerErrorResponse>(
    ['textEntities'],
    async ({ signal }): Promise<{ content: TextEntityResponse[] }> => {
      try {
        const data = await fetcher({
          method: 'GET',
          url: `${baseApiUrl()}/lexiverse/text-entity/v1/text-entities`,
          options: { signal },
        });
        return data;
      } catch (error: unknown) {
        if (onError && typeof error === 'object' && error !== null && 'errorDetails' in error) {
          onError(error as ServerErrorResponse);
        }
        throw error;
      }
    },
    {
      ...options,
    }
  );
}
